import { NotifyHelper } from "../../../helpers/toast";
import { eNgayNghiLeActionsObj } from "../../action-types/category/INgayNghiLeActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const ngayNghiLeActions = {
    ...generateActions(eNgayNghiLeActionsObj, "NGAY_NGHI_LE"),
    ...generateActionForKey(eNgayNghiLeActionsObj, "NGAY_NGHI_LE", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eNgayNghiLeActionsObj, "NGAY_NGHI_LE", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eNgayNghiLeActionsObj, "NGAY_NGHI_LE", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eNgayNghiLeActionsObj, "NGAY_NGHI_LE", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
